import "./helper/image";
import "./helper/slider";

window.$ = window.jQuery = require('jquery');

require('bootstrap/js/src/collapse');
require('bootstrap/js/src/modal');
require('bootstrap/js/src/dropdown');

window.Vue = require("vue");
import Vue from "vue";


// Business page
require('bootstrap/js/src/tab');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.component("cert-reseller", require("./components/search/CertifiedReseller.vue").default);
Vue.component("business-listing-tabs", require("./components/businesslisting/BusinessListingTabs.vue").default);
Vue.component("pagination", require("./components/Pagination").default);
Vue.component("display-review", require("./components/DisplayReview.vue").default);
Vue.component("media-share", require("./components/search/MediaShare.vue").default);

// Home page
Vue.component("location-select", require("./components/header/LocationSelect.vue").default);
Vue.component("report-issue-modal", require("./components/ReportIssueModal").default);
Vue.component("navigate-top", require("./components/search/NavigateTop").default);

// Search page
Vue.component("search-filter", require("./components/search/SearchFilter.vue").default);

// Faq
Vue.component("faq", require("./components/Faq.vue").default);

new Vue({ el: "#app" });
